<template>
    <div class="pagination" :class="{hide: !itemsTotal}">
        <button
                :disabled="currentPage <= 1"
                title="Previous"
                @click="prev"
        >
            <i class="icon-angle-left"></i>
        </button>
        <button
                :class="{ active: isActive(1) }"
                @click="setActivePage(1)"
        >1</button>

        <span v-if="currentPage > 4" class="dots">...</span>

        <template v-for="(page, i) in pagesAround" :key="i">
            <button v-if="page"
                  :class="{ active: isActive(page) }"
                  @click="setActivePage(page)"
            >{{ page }}</button>
        </template>

        <span v-if="currentPage < pagesTotal - 3" class="dots">...</span>

        <button v-if="pagesTotal > 1"
                :class="{ active: isActive(pagesTotal) }"
                @click="setActivePage(pagesTotal)"
        >{{ pagesTotal }}</button>
        <button
                :disabled="currentPage >= pagesTotal"
                title="Next"
                @click="next"
        >
            <i class="icon-angle-right"></i>
        </button>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';

    export default {
        name: "Pagination",

        emits: [
            'changedPage',
        ],

        computed: {
            ...mapState('pagination', [
                'currentPage',
                'pageSize',
                'itemsTotal',
            ]),

            ...mapGetters('pagination', [
                'pagesTotal',
            ]),

            pagesAround() {
                return Array.from({length: 5}, (_, i) => {
                    let current = this.currentPage - 2 + i;

                    return current < 2 ? 0 :
                        current > this.pagesTotal - 1 ? 0 : current;
                });

            },


        },

        methods: {
            ...mapActions('pagination', [
                'setPage',
            ]),

            async setActivePage(page) {
                await this.setPage(page);

                this.setRouteQuery(page);

                this.$emit('changedPage', this.currentPage)
            },

            setRouteQuery(page) {
                const query = { ...this.$route.query, page };
                const route = { path: this.$route.path, query};

                this.$router.push(route);
            },

            isActive(page) {
                return this.currentPage === page;
            },

            prev() {
                let page = this.currentPage - 1;

                this.setActivePage(page);
            },

            next() {
                let page = this.currentPage + 1;

                this.setActivePage(page);
            },

        },

    }
</script>

<style scoped>
    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
    }

    button {
        min-width: 40px;
        height: 40px;
        margin: 0 3px;
        padding: 0;
        border: 1px solid #bbb;
        border-radius: 5px;
        font-size: 16px;
        line-height: 38px;
        text-align: center;
        background: #eee;
    }

    button:not([disabled]) {
        color: #333;
    }

    i {
        font-size: 22px;
    }

    .dots {
        margin: 0 5px;
    }

    .hide {
        display: none !important;
    }

    button:not([disabled]):hover,
    .active {
        border-color: #999;
        color: #444;
        background: #ccc;
    }

    .active {
        font-weight: 700;
        cursor: default;
    }
</style>